﻿// NG 2
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Animations } from '../common/animations';

@Component({
    selector: 'app-help',
    templateUrl: './help.component.html', 
    animations: [Animations.collapseInOut]
})
export class HelpComponent implements OnInit {

    loading = false;
    notification: any;
    //isLoginPage: boolean = true;
    qa1: boolean = true; 
    qa2: boolean = true;
    qa3: boolean = true;
    qa4: boolean = true;
    qa5: boolean = true;
    qa6: boolean = true;
    qa7: boolean = true;
    qa8: boolean = true;
    qa9: boolean = true;
    qa10: boolean = true;
    qa11: boolean = true;
    qa12: boolean = true;
    qa13: boolean = true;

    constructor(
        private route: ActivatedRoute,
        private router: Router
        
    ) { }

    ngOnInit() {

        }
    
    }



